import Vue from 'vue';

import { ILeaseIngestion } from '@/bundles/LeaseIngestion/types';
import { Nullable } from '@/utils/types';

import { LeaseIngestionMutationsEnum } from './lease-ingestion-types';
import { ILeaseIngestionListing, ILeaseIngestionStore } from './index';

export default {
  [LeaseIngestionMutationsEnum.UpsertRecord] (state: ILeaseIngestionStore, record: ILeaseIngestion) {
    Vue.set(state.records, record._key, record);
  },

  [LeaseIngestionMutationsEnum.UpsertRecords] (state: ILeaseIngestionStore, records: ILeaseIngestion[]) {
    records.forEach((record) => {
      Vue.set(state.records, record._key, record);
    });
  },

  [LeaseIngestionMutationsEnum.RemoveRecord] (state: ILeaseIngestionStore, key: string) {
    Vue.delete(state.records, key);
  },

  [LeaseIngestionMutationsEnum.SetListing] (
    state: ILeaseIngestionStore,
    { key, listing }: { key: string; listing: ILeaseIngestionListing },
  ) {
    Vue.set(state.listings, key, listing);
  },

  [LeaseIngestionMutationsEnum.SetListingLoading] (
    state: ILeaseIngestionStore,
    { key, loading }: { key: string; loading: boolean },
  ) {
    const existing: ILeaseIngestionListing = state.listings[key] ?? { ids: [], loading: false, error: null };
    Vue.set(state.listings, key, { ...existing, loading });
  },

  [LeaseIngestionMutationsEnum.SetListingError] (
    state: ILeaseIngestionStore,
    { key, error }: { key: string; error: Nullable<string> },
  ) {
    const existing: ILeaseIngestionListing = state.listings[key] ?? { ids: [], loading: false, error: null };
    Vue.set(state.listings, key, { ...existing, error });
  },

  [LeaseIngestionMutationsEnum.SetActiveId] (state: ILeaseIngestionStore, id: Nullable<string>) {
    state.activeId = id;
  },

  [LeaseIngestionMutationsEnum.SetDetailLoading] (state: ILeaseIngestionStore, loading: boolean) {
    state.detailLoading = loading;
  },

  [LeaseIngestionMutationsEnum.SetDetailError] (state: ILeaseIngestionStore, error: Nullable<string>) {
    state.detailError = error;
  },
};
